import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(t('auth.passwordResetEmailSent'));
    } catch (err) {
      console.error('Password reset error:', err);
      
      switch (err.code) {
        case 'auth/user-not-found':
          setError(t('errors.noAccountFound'));
          break;
        case 'auth/invalid-email':
          setError(t('errors.invalidEmail'));
          break;
        case 'auth/too-many-requests':
          setError(t('errors.tooManyResetRequests'));
          break;
        default:
          setError(t('errors.resetEmailFailed'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO
        title="Reset Password - Osailu"
        description="Reset your Osailu account password. Enter your email address to receive password reset instructions."
        keywords="Osailu password reset, forgot password, recover account"
        url="/forgot-password"
        noindex={true}
      />
      <div style={{ 
        minHeight: 'calc(100vh - 120px)', 
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        padding: '20px 0'
      }}>
      <div className="container mt-5">
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card>
            <Card.Header className="text-center">
              <h3>{t('auth.resetPassword')}</h3>
              <p className="text-muted mb-0">{t('auth.resetPasswordDescription')}</p>
            </Card.Header>
            <Card.Body>
              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}

              {success && (
                <Alert variant="success" className="mb-3">
                  {success}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>{t('auth.emailAddress')}</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t('auth.enterEmail')}
                    required
                    autoComplete="email"
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mb-3"
                  disabled={loading}
                >
                  {loading ? t('auth.sending') : t('auth.sendResetEmail')}
                </Button>
              </Form>

              <div className="text-center">
                <p className="mb-0">
                  {t('auth.rememberPassword')}{' '}
                  <Link to="/login" className="text-decoration-none">
                    {t('auth.signInHere')}
                  </Link>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
    </div>
    </>
  );
};

export default ForgotPassword;
